export interface AppConfig {
  DATA_ADMIN_API_URL: string;
  USER_POOL_ID: string;
  USER_POOL_CLIENT_ID: string;
  ENV: string;
  REGION: string;
  AWS_RUM_APP_ID: string;
  AWS_RUM_POOL_ID: string;
}

export function getAppConfig(): AppConfig {
  return {
    DATA_ADMIN_API_URL: import.meta.env.VITE_DATA_ADMIN_API_URL.endsWith('/')
      ? import.meta.env.VITE_DATA_ADMIN_API_URL.slice(0, -1)
      : import.meta.env.VITE_DATA_ADMIN_API_URL,
    USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID,
    ENV: import.meta.env.VITE_ENV || '',
    USER_POOL_CLIENT_ID: import.meta.env.VITE_USER_POOL_CLIENT_ID,
    REGION: import.meta.env.VITE_REGION,
    AWS_RUM_APP_ID: import.meta.env.VITE_AWS_RUM_APP_ID,
    AWS_RUM_POOL_ID: import.meta.env.VITE_AWS_RUM_POOL_ID
  };
};
